import React, { Component } from 'react'
import Activity from "framework/containers/Activity"
import FormAction from 'app/modules/Accounting/reports/CashierReport/CashierReportAction'

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class CashierReportActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/modules/Accounting/reports/CashierReport/CashierReport")
	}

	render() {
		return (
			<Activity 
				name="CashierReport"
				RenderedComponent={this.RenderedComponent}
				context="CashierReport"
				action="CashierReport"
				formActions={FormAction}/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(CashierReportActivity)
